/**
 * Shuffle the logos order on each page load.
 * Done client-side so the random order isn't frozen by the page cache.
 */
document
  .querySelectorAll('.logos-grid-group .acf-innerblocks-container')
  .forEach((container) => {
    const items = [...container.querySelectorAll(':scope > .logos-grid-item')];
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    items.forEach((item) => container.appendChild(item));
  });
